module.exports = __webpack_public_path__ + "img/smartrx_logo.9fff7ee5.svg";